import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Ban, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const praticaId = params.get("pratica_id");
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] text-slate-100 px-5">
      <div data-testid="payment-cancel-card" className="max-w-md w-full rounded-2xl border border-slate-800 bg-[#121824] p-8 text-center">
        <Ban className="h-12 w-12 text-amber-400 mx-auto mb-4" />
        <h1 className="font-heading text-xl font-bold">Pagamento annullato</h1>
        <p className="text-sm text-slate-400 mt-2">Nessun addebito è stato effettuato. Puoi riprovare in qualsiasi momento dalla pratica.</p>
        <button data-testid="payment-cancel-back-btn" onClick={() => navigate(praticaId ? `/pratica/${praticaId}` : "/dashboard")}
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#1A2332] border border-slate-700 hover:border-cyan-500/50">
          <ArrowLeft className="h-4 w-4" /> {praticaId ? "Torna alla pratica" : "Vai alle pratiche"}
        </button>
      </div>
    </div>
  );
}
